module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('swiper', {
    ref: "swiper",
    attrs: {
      "options": _vm.swiperOptions
    }
  }, [_c('swiper-slide', [_c('div', {
    staticClass: "slide-content"
  }, [_c('div', {
    staticClass: "lead-form"
  }, [_c('div', {
    staticClass: "form-header"
  }, [_c('div', {
    staticClass: "header-image",
    style: ({
      'background-image': 'url(' + _vm.headerImage + ')'
    })
  }), _c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.fbPage.picture,
      "width": "74",
      "height": "74"
    }
  }), _c('h6', [_vm._v(_vm._s(_vm.fbPage.name))]), _c('p', {
    staticClass: "call-to-action"
  }, [_vm._v(_vm._s(_vm.$t('pos.postPreview.lead-form.cta')))])]), (_vm.isLeadQuestionVisible) ? _c('div', {
    staticClass: "form-container"
  }, [_c('div', {
    staticClass: "question"
  }, [_vm._v(_vm._s(_vm.question)), _c('b-form-input', {
    attrs: {
      "placeholder": _vm.$t("pos.postPreview.lead-form.placeholder.enquiry"),
      "disabled": true
    }
  })], 1)]) : _vm._e(), _vm._l((_vm.inputFields), function(label) {
    return _c('div', {
      staticClass: "form-container"
    }, [_c('label', [_vm._v(_vm._s(_vm.$t(("pos.postPreview.lead-form.label." + (label.toLowerCase())))))]), _c('b-form-input', {
      attrs: {
        "placeholder": _vm.$t(("pos.postPreview.lead-form.placeholder." + (label.toLowerCase()))),
        "disabled": true
      }
    })], 1)
  }), _c('p', {
    staticClass: "agreement"
  }, [_vm._v(_vm._s(_vm.$t('pos.postPreview.lead-form.policy.summary', {
    company: _vm.fbPage.name
  })) + " "), _c('a', {
    attrs: {
      "href": "https://www.facebook.com/policy",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.postPreview.lead-form.policy.view-facebook')))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.getPrivacyUrl(),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.postPreview.lead-form.policy.view-company', {
    company: _vm.fbPage.name
  })))])])], 2), _c('div', {
    staticClass: "button-container"
  }, [_c('b-button', [_vm._v(_vm._s(_vm.$t('pos.buttons.back')))]), _c('b-button', {
    staticClass: "submit"
  }, [_vm._v(_vm._s(_vm.$t('pos.buttons.submit')))])], 1)])]), _c('swiper-slide', [_c('div', {
    staticClass: "slide-content"
  }, [_c('div', {
    staticClass: "lead-form"
  }, [_c('div', {
    staticClass: "form-header"
  }, [_c('div', {
    staticClass: "header-image",
    style: ({
      'background-image': 'url(' + _vm.headerImage + ')'
    })
  }), _c('h6', [_c('span', {
    staticClass: "avatar",
    style: ({
      'background-image': 'url(' + _vm.fbPage.picture + ')'
    })
  }, [_vm._v(_vm._s(_vm.fbPage.name))])]), _c('p', {
    staticClass: "call-to-action"
  }, [_vm._v(_vm._s(_vm.$t('pos.postPreview.lead-form.thanks')))]), _c('p', {
    staticClass: "done-message"
  }, [_vm._v(_vm._s(_vm.$t('pos.postPreview.lead-form.thanks-message')))])])]), _c('div', {
    staticClass: "button-container"
  }, [_c('b-button', {
    staticClass: "check-out"
  }, [_vm._v(_vm._s(_vm.$t('pos.postPreview.lead-form.check-out')))])], 1)])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c913027"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/gotu-vue-common/src/components/lead-form-preview/LeadFormPreview.vue
// module id = 2013
// module chunks = 1